



























































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { getSubscriptions, patchSubscription } from '@/api/api';
import MetaDatatable from '../models/MetaDatatable';
import moment from 'moment';
import { fetchPrescriber } from '@/utils/filters';
import FilterComponent from '@/components/FilterComponent.vue';
// @ts-ignore
import localeFr from 'ant-design-vue/lib/date-picker/locale/fr_FR';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';

@Component({ components: { FilterComponent } })
class Subscriptions extends Vue {
    moment = moment;
    localeFr = localeFr;
    items: any[] = [];
    loadingData = false;
    private reloadPending = false;

    defaultMeta: MetaDatatable = {
        total: 0,
        pages: 0,
        page: 1,
        perPage: 20,
        search: null,
        orderBy: null,
        orderWay: null,
        filters: { prescriber: undefined },
    };
    meta: MetaDatatable = cloneDeep(this.defaultMeta);
    prescriberModel: string | undefined | null = null;

    async created() {
        await this.loadData();
    }

    async loadData() {
        this.loadingData = true;
        try {
            const { data } = await getSubscriptions({
                ...this.meta,
                page: this.meta.page - 1,
            });
            this.items = data.data || [];
            this.meta.total = (data.meta && data.meta.total) || 0;
            this.meta.pages = (data.meta && data.meta.pages) || 1;
        } finally {
            this.loadingData = false;
        }
    }

    scheduleReload() {
        if (!this.reloadPending) {
            this.reloadPending = true;
            this.$nextTick(async () => {
                this.reloadPending = false;
                await this.loadData();
            });
        }
    }

    @Watch('meta.page')
    onPageChange() {
        this.scheduleReload();
    }

    @Watch('meta.search')
    onSearchChange() {
        this.meta.page = 1;
        this.scheduleReload();
    }

    @Watch('meta.filters', { deep: true })
    onFiltersChange() {
        this.meta.page = 1;
        this.scheduleReload();
    }

    get fetchPrescriber() {
        return fetchPrescriber;
    }

    get paginationInfo(): string {
        const start = (this.meta.page - 1) * this.meta.perPage + 1;
        const end = Math.min(this.meta.page * this.meta.perPage, this.meta.total);
        return `${start}–${end}`;
    }

    get visiblePages(): number[] {
        const pages = this.meta.pages || 1;
        const current = this.meta.page;
        const range: number[] = [];
        for (let i = Math.max(1, current - 2); i <= Math.min(pages, current + 2); i++) {
            range.push(i);
        }
        return range;
    }

    goToPage(page: number) {
        this.meta.page = page;
    }

    onPerPageChange(event: Event) {
        this.meta.perPage = parseInt((event.target as HTMLSelectElement).value);
        this.meta.page = 1;
        this.scheduleReload();
    }

    resetFilters() {
        this.meta = cloneDeep(this.defaultMeta);
        this.prescriberModel = null;
        this.loadData();
    }

    getInitials(prescriber: any): string {
        if (!prescriber) return '?';
        const f = (prescriber.firstname || '').charAt(0).toUpperCase();
        const l = (prescriber.lastname || '').charAt(0).toUpperCase();
        return (f + l) || '?';
    }

    getFullname(prescriber: any): string {
        if (!prescriber) return '';
        return `${prescriber.firstname || ''} ${prescriber.lastname || ''}`.trim();
    }

    getAvatarColor(prescriber: any): string {
        const palette = ['#7367F0', '#28C76F', '#FF9F43', '#EA5455', '#00CFE8', '#9c27b0', '#f06292'];
        const name = prescriber ? (prescriber.firstname || '') : '';
        const code = name.charCodeAt(0) || 0;
        return palette[code % palette.length];
    }

    isActive(sub: any): boolean {
        return moment(sub.end_at).isAfter(moment());
    }

    formatDate(date: string): string {
        return moment(date).format('DD/MM/YYYY');
    }

    editText = {
        notify: {
            title: 'Date de fin modifiée',
            content: `L'abonnement a bien été modifié`,
        },
    };

    async editEndAt(date: moment.Moment, subscription: any) {
        const DATE_TIME_PHP = 'YYYY-MM-DDTHH:mm:ssZZ';
        subscription.end_at = date.format(DATE_TIME_PHP);

        const $vs = (this as any).$vs;
        try {
            if (subscription && subscription.id) {
                await patchSubscription(subscription.id, { end_at: subscription.end_at });
                $vs.notify({
                    color: 'success',
                    position: 'top-right',
                    title: this.editText.notify.title,
                    text: this.editText.notify.content,
                });
            }
        } catch (error) {
            const message = get(error, 'response.data.message', `Erreur lors de la modification de l'abonnement`);
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: message,
            });
        }
    }

    @Watch('meta', { deep: true, immediate: true })
    onMeta() {
        if (this.meta.filters && this.meta.filters.prescriber) {
            this.prescriberModel = this.meta.filters.prescriber;
        } else {
            this.prescriberModel = undefined;
        }
    }

    @Watch('prescriberModel', { immediate: true })
    onPrescriberModel() {
        if (this.prescriberModel) {
            this.meta.filters.prescriber = this.prescriberModel;
        } else if (this.meta.filters) {
            this.meta.filters.prescriber = null;
        }
    }
}

export default Subscriptions;
